import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";

export default function SummaryBlock(props) {
  const { items = [], columns = 2 } = props;
  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gap: 2,
      }}
    >
      {items.map((item, idx) => (
        <Card
          key={idx}
          sx={{
            bgcolor: "background.paper",
            borderRadius: 2,
            border: "1px solid",
            borderColor: "divider",
            boxShadow: 0,
          }}
        >
          <CardContent>
            <Typography variant="subtitle2" color="text.secondary">
              {item.label}
            </Typography>
            <Typography variant="h6" fontWeight="bold">
              {item.value}
            </Typography>
            {item.caption && (
              <Typography variant="body2" color="text.secondary">
                {item.caption}
              </Typography>
            )}
          </CardContent>
        </Card>
      ))}
    </Box>
  );
}
